import { codeToRegion } from '../common/utils/region';

const initialState = {};
const loading = {};
const RECEIVE = 'regions/RECEIVE';

export function receiveRegion(region) {
  return { type: RECEIVE, payload: region };
}

export function loadRegion(code) {
  return (dispatch, getState) => {
    if (loading[code]) return;
    if (getState().regions[code]) return;

    loading[code] = true;
    return codeToRegion(code)
      .then((region) => dispatch(receiveRegion(region)))
      .catch(() => null)
      .then(() => delete loading[code]);
  };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return Object.assign({}, state, { [payload.code]: payload });

    default:
      return state;
  }
}
